export const DASHBOARD_LABELS = {
	WEB_DASHBOARD_TITLE: 'Web Dashboard',
	ACCESSIBILITY_PERFORMANCE_TRENDS: 'Accessibility performance trends',
	BUSINESS_UNITS: 'Business Units',
	LAST_UPDATED: 'Last updated'
};
